// extracted by mini-css-extract-plugin
export const sidebar = "sidebar-module--sidebar--lvO1W";
export const sidebar__inner = "sidebar-module--sidebar__inner--290ZN";